import { useSessionValue } from 'appLayer/auth';
import { showNotification } from 'shared/ui/Notification';
import { subscriptionActivateClickEvent } from 'analytics/events';
import { useMutation } from '@tanstack/react-query';
import { useInternalApiRequest } from 'shared/hooks/useInternalApiRequest';
import { InternalApiRequestError } from 'shared/hooks/useInternalApiRequest/types';
import { useCreatePerformanceTimer } from 'shared/hooks/useCreatePerformanceTimer';

import { SUBSCRIPTION_API_URL } from '@portal/config/base';
import { useStoreValue } from '../../hooks/useStore';
import {
  ActivateSubscriptionV2Request,
  ActivateSubscriptionDetailsV2InitialResponse
} from './types';

export const useMutationReactivateSubscriptionV2 = () => {
  const createPerformanceTimer = useCreatePerformanceTimer();
  const session = useSessionValue();
  const store = useStoreValue();
  const request = useInternalApiRequest();

  const customerId = session?.customer?.id;

  const timer = createPerformanceTimer('reactivateSubscription');

  return useMutation<
    ActivateSubscriptionDetailsV2InitialResponse,
    InternalApiRequestError,
    ActivateSubscriptionV2Request
  >({
    mutationFn: ({ subscriptionId }: ActivateSubscriptionV2Request) =>
      request<ActivateSubscriptionDetailsV2InitialResponse>({
        method: 'POST',
        url: `${SUBSCRIPTION_API_URL[store]}/user/subscription/${subscriptionId}/activate`
      }),
    onSuccess: (_response, { subscriptionId }) => {
      if (customerId) {
        timer.success();

        subscriptionActivateClickEvent({
          customerId,
          subscriptionId,
          store
        });
      }
    },
    onError: (error) => {
      timer.failure(error);
      showNotification('mutationError');
    }
  });
};
